import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { playClickSound } from '@/utils/soundUtils';

export type NavigationFromState = { from?: string };

/** Pass when navigating forward so `< Back` can return to the entry page. */
export function navigationFromState(from: string): { state: NavigationFromState } {
  return { state: { from } };
}

/**
 * Browser back when possible; otherwise `location.state.from`, then `fallback`.
 * Use for in-page `< Back` chips (deposit, wallet top-up, etc.).
 */
export function useNavigateBack(fallback: string) {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(() => {
    playClickSound();
    const from = (location.state as NavigationFromState | null)?.from;
    if (from && from !== location.pathname) {
      navigate(from);
      return;
    }
    if (typeof window !== 'undefined' && window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate(fallback);
  }, [fallback, location.pathname, location.state, navigate]);
}
